import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import Style from "./languageMenu.module.scss";
import { getSupportedLanguages } from "../../reusable/functions";

interface LanguageMenuProps {
  style?: CSSProperties | undefined;
  closeMenu: () => void;
  changeLanguageLabel: (lan: string) => void;
}

const LanguageMenu = (props: LanguageMenuProps) => {
  const { i18n } = useTranslation();

  const handleClick = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div
      className={
        isMobile ? Style.languageMenuMobile : Style.languageMenuDesktop
      }
      style={props.style}
    >
      {getSupportedLanguages().map((lang: string) => (
        <div
          key={lang}
          className={Style.language}
          onClick={() => {
            handleClick(lang);
            props.closeMenu();
            props.changeLanguageLabel(lang.toUpperCase());
            localStorage.setItem("beppoSelectedLanguage", lang);
          }}
        >
          {lang.toUpperCase()}
        </div>
      ))}
    </div>
  );
};

export default LanguageMenu;
